import { FC, ReactNode, useState } from "react";

interface SidebarLinkGroupProps {
    activeCondition: boolean;
    children: (handleClick: () => void, open: boolean) => ReactNode;
}

export const SidebarLinkGroup: FC<SidebarLinkGroupProps> = ({ activeCondition, children }) => {
    const [open, setOpen] = useState(true);

    const handleClick = () => {
        setOpen(!open);
    }


    return (
        <li className={`pl-4 pr-3 py-2 rounded-lg mb-0.5 last:mb-0 bg-linear-to-r ${activeCondition && 'from-violet-500/[0.12] dark:from-violet-500/[0.24] to-violet-500/[0.04]'}`}>
            {children(handleClick, open)}
        </li>
    );
}